import React, { ReactNode } from "react";
import { useAuth } from "../../auth/AuthContext";
import { Loading } from "../common/Loading";
import { LoginPage } from "../../pages/LoginPage";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <Loading message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
